<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import zeroSearchResultPngHg from '@/assets/images/zero-search-result-hg.png';
import zeroSearchResultPngIs24 from '@/assets/images/zero-search-result-is24.png';
import { isPlatformIs24 } from '@/helpers/Platform/platform';

const zeroSearchResultImageSrc = isPlatformIs24() ? zeroSearchResultPngIs24 : zeroSearchResultPngHg;

const { t } = useI18n();
</script>

<template>
  <div :class="$style.zeroSearchResultWrapper">
    <img :src="zeroSearchResultImageSrc" alt="zero search result" />
    <div :class="$style.textWrapper">
      <span>{{ t('agencyList.noAgenciesFound') }}</span>
      <span>{{ t('agencyList.tryAnotherLocation') }}</span>
    </div>
  </div>
</template>

<style module lang="scss">
@use '@/assets/variables' as *;

.zeroSearchResultWrapper {
  display: block;

  @media (min-width: $viewport-sm-min) {
    display: flex;
    align-items: center;
  }

  .textWrapper {
    font-size: 20px;

    @media (min-width: $viewport-sm-min) {
      margin-left: $space-150;
    }

    span {
      display: block;

      &:first-child {
        margin-bottom: $space-50;
        font-weight: bold;
      }
    }
  }
}
</style>
